import React, { useEffect, useState } from 'react';
import Defaultaddress from '../../User/components/Default_address';
import { Button, Stack, Typography } from '@mui/material';
import Addedaddress from '../../User/components/Added_address';
import pickup_complete from '../../User/assets/pickup_successful.svg'
import { useNavigate } from 'react-router-dom';
import Uploadeddesigns from '../../User/components/Uploaded_designs';
import instance from '../../Utils/api';



const Pickuporder = () => {
    const navigate = useNavigate();
    // Initialize state for activeStep
    const [currentStep, setCurrentStep] = useState(1); // Manage the active step
    const [selectedId, setSelectedId] = useState(null);

    const steps = ['Your order', 'Pickup address', 'Order successfully'];

    const nextStep = () => {
        if (currentStep < steps.length - 1) {
            setCurrentStep(currentStep + 1);
        }
    };

    const prevStep = () => {
        if (currentStep > 0) {
            setCurrentStep(currentStep - 1);
        }
    };

    const [addresses, setAddresses] = useState();


    const getAddressData = async () => {
        try {
            const response = await instance.get('Address/getAddress');
            // console.log(response);
            setAddresses(response.data.data);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(() => {
        getAddressData();
    }, []);
    return (
        <React.Fragment>
            <section className='catalogue-order'>
                <div className="stepper-wrapper">
                    {steps.map((step, index) => (
                        <div
                            key={index}
                            className={`stepper-item ${index < currentStep ? 'completed' : ''} ${index === currentStep ? 'active' : ''}`}
                            onClick={() => setCurrentStep(index)} // Add onClick event here
                            style={{ cursor: 'pointer' }} // Add cursor style to indicate clickability
                        >
                            <div className="step-counter"></div>
                            <div className="step-name">{step}</div>
                        </div>
                    ))}
                </div>
                {/* Dynamic Content for Each Step */}
                <div className="step-content">
                    {currentStep === 0 && (
                        <>

                            <Uploadeddesigns />
                        </>
                    )}
                    {currentStep === 1 && (
                        <div className='catalogue-order'>
                            <Stack gap={'10px'}>
                                {addresses?.length ? addresses.map((data) => (
                                    <Defaultaddress
                                        data={data}
                                        selectedId={selectedId}
                                        onSelect={setSelectedId}
                                    />)) : null}
                            </Stack>
                        </div>
                    )}
                    {currentStep === 2 && (
                        <div className='catalogue-order'>
                            <div className='cart-no-items'>
                                <img src={pickup_complete} alt='pickup_complete' />
                                <Typography>Order placed successfully!</Typography>
                            </div>
                        </div>
                    )}
                </div>
            </section>
        </React.Fragment>
    )
}

export default Pickuporder